import styled from 'styled-components';

const SidebarContainer = styled.div`
  text-align: center;

  &.rtl {
    .sidebar-header {
      flex-direction: row-reverse;
    }
    .menu-link,
    .category-pill {
      flex-direction: row-reverse;
      text-align: right;
    }
    .chevron {
      transform: rotate(180deg);
    }
    .section-title {
      text-align: right;
    }
    .offers-banner {
      flex-direction: row-reverse;
    }
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 85%;
    max-width: 380px;
    height: 100%;
    background: var(--clr-warm-white, #ffffff);
    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateX(-100%);
    z-index: -1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    -webkit-overflow-scrolling: touch;
    box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);
  }

  .show-sidebar {
    transform: translateX(0);
    z-index: 999;
  }

  .sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.25rem;
    background: var(--clr-warm-white, #ffffff);
    border-bottom: 1px solid var(--clr-beige, #f5f5f5);
    min-height: 64px;
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .sidebar-brand {
    font-family: var(--font-display, serif);
    font-size: 1.5rem;
    font-weight: 600;
    color: var(--clr-charcoal, #2c3e50);
    text-decoration: none;
    letter-spacing: -0.5px;
  }

  .close-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--clr-beige, rgba(139, 92, 69, 0.08));
    border: none;
    border-radius: 50%;
    color: var(--clr-charcoal, #2c3e50);
    font-size: 1rem;
    cursor: pointer;
    transition: all 0.2s ease;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;

    &:hover, &:active {
      background: var(--clr-beige-dark, rgba(139, 92, 69, 0.15));
      transform: scale(0.95);
    }
  }

  .sidebar-content {
    flex: 1;
    padding: 1.5rem 1.25rem;
    overflow-y: auto;
  }

  .nav-section {
    margin-bottom: 2rem;
  }

  .section-title {
    font-family: var(--font-body, sans-serif);
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    color: var(--clr-charcoal-light, #94a3b8);
    margin: 0 0 1rem 0;
    text-align: left;
  }

  .links {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .menu-link {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.875rem 1rem;
    color: var(--clr-charcoal, #2c3e50);
    text-decoration: none;
    font-family: var(--font-body, sans-serif);
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.2s ease;
    border-radius: 12px;
    background: transparent;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;

    &:hover, &:active {
      background: var(--clr-beige, rgba(139, 92, 69, 0.06));

      .link-icon-wrapper {
        background: rgba(139, 92, 69, 0.12);
      }

      .link-icon {
        color: var(--clr-olive, #8b7055);
      }

      .chevron {
        opacity: 1;
        color: var(--clr-olive, #8b7055);
        transform: translateX(3px);
      }
    }
  }

  .link-icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--clr-beige, rgba(139, 92, 69, 0.08));
    border-radius: 12px;
    transition: all 0.2s ease;
  }

  .link-icon {
    font-size: 1.25rem;
    color: var(--clr-olive, #8b7055);
    transition: all 0.2s ease;
  }

  .link-text {
    flex: 1;
    text-align: left;
  }

  .chevron {
    color: var(--clr-charcoal-light, #cbd5e1);
    font-size: 0.75rem;
    opacity: 0.5;
    transition: all 0.2s ease;
  }

  /* Categories Section */
  .categories-section {
    .section-title {
      margin-bottom: 1rem;
    }
  }

  .categories-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
  }

  .category-pill {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.625rem 1rem;
    background: var(--clr-beige, rgba(139, 92, 69, 0.06));
    border: 1px solid var(--clr-beige-dark, rgba(139, 92, 69, 0.15));
    border-radius: 100px;
    color: var(--clr-charcoal, #2c3e50);
    font-family: var(--font-body, sans-serif);
    font-size: 0.875rem;
    font-weight: 500;
    text-transform: capitalize;
    cursor: pointer;
    transition: all 0.2s ease;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;

    &:hover, &:active {
      background: var(--clr-olive, #8b7055);
      border-color: var(--clr-olive, #8b7055);
      color: var(--clr-warm-white, white);
      transform: scale(0.97);

      .category-icon {
        color: var(--clr-warm-white, white);
      }
    }
  }

  .category-icon {
    font-size: 1rem;
    color: var(--clr-olive, #8b7055);
    transition: all 0.2s ease;
  }

  .category-name {
    white-space: nowrap;
  }

  /* Special Offers Banner */
  .offers-banner {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1.25rem;
    margin: 2rem 0 1.5rem;
    background: linear-gradient(135deg, rgba(212, 175, 55, 0.15) 0%, rgba(212, 175, 55, 0.05) 100%);
    border: 1px solid rgba(212, 175, 55, 0.2);
    border-radius: 16px;
    text-decoration: none;
    transition: all 0.2s ease;
    touch-action: manipulation;

    &:hover, &:active {
      transform: scale(0.98);
      box-shadow: 0 4px 12px rgba(212, 175, 55, 0.15);
    }
  }

  .offers-icon-wrapper {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(212, 175, 55, 0.2);
    border-radius: 50%;
    flex-shrink: 0;
  }

  .offers-icon {
    font-size: 1.5rem;
    color: var(--clr-gold, #d4af37);
  }

  .offers-content {
    flex: 1;
    text-align: left;
  }

  .offers-title {
    font-family: var(--font-display, serif);
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--clr-charcoal, #2c3e50);
    margin: 0 0 0.25rem 0;
  }

  .offers-subtitle {
    font-family: var(--font-body, sans-serif);
    font-size: 0.875rem;
    color: var(--clr-charcoal-light, #64748b);
    margin: 0;
  }

  /* Bottom Actions */
  .bottom-actions {
    display: flex;
    justify-content: center;
    padding-top: 1.5rem;
    border-top: 1px solid var(--clr-beige, #f0f0f0);
  }

  .action-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.625rem;
    padding: 0.875rem 1.5rem;
    background: var(--clr-beige, rgba(139, 92, 69, 0.06));
    border-radius: 12px;
    text-decoration: none;
    transition: all 0.2s ease;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;

    &:hover, &:active {
      background: var(--clr-beige-dark, rgba(139, 92, 69, 0.12));
      transform: scale(0.98);
    }
  }

  .account-btn {
    min-width: 140px;
  }

  .action-icon {
    font-size: 1.25rem;
    color: var(--clr-olive, #8b7055);
  }

  .action-text {
    font-family: var(--font-body, sans-serif);
    font-size: 0.875rem;
    font-weight: 500;
    color: var(--clr-charcoal, #2c3e50);
  }

  @media screen and (min-width: 992px) {
    .sidebar {
      display: none;
    }
  }
`;

export default SidebarContainer;
